import type { FilterOption } from '@/components/FilterMenu'
import { FilterMenu } from '@/components/FilterMenu'
import { useTranslation } from 'react-i18next'

interface SortFilterProps {
  options: FilterOption[]
  selectedOption: FilterOption
  onChange: (option: FilterOption | null) => void
}

export function SortFilter({
  options,
  selectedOption,
  onChange,
}: SortFilterProps) {
  const { t } = useTranslation()

  return (
    <FilterMenu
      buttonLabel={t('clusterConfigTable.filters.sort')}
      headerTitle={t('clusterConfigTable.filters.sortBy') as string}
      options={options}
      selectedOption={selectedOption}
      onOptionChange={onChange}
      menuWidth={150}
      data-testid="sort-filter"
    />
  )
}
